import PropTypes from "prop-types";
import React from "react";
import ReactGA from "react-ga";
import { Link as RRLink, NavLink as RRNavLink } from "react-router-dom";

const track = ({ label, to }) => {
  ReactGA.event({ category: "Click", action: to, label });
};

export const Link = ({ label = "Link", to, ...props }) => (
  <RRLink
    onClick={() => {
      track({ label, to });
    }}
    to={to}
    {...props}
  />
);

export const NavLink = ({ label = "NavLink", to, ...props }) => (
  <RRNavLink
    onClick={() => {
      track({ label, to });
    }}
    to={to}
    {...props}
  />
);

Link.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  to: PropTypes.string.isRequired,
};

NavLink.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  to: PropTypes.string.isRequired,
};
